import {
  Link2,
  Shirt,
  Utensils,
  Sparkles,
  Dumbbell,
  Palette,
  Cpu,
  GraduationCap,
  ShoppingBag,
  Briefcase,
  MoreHorizontal,
  Globe,
  Music2,
  Store,
  Radio,
  Heart,
  PenLine,
  Phone,
  MapPin,
  CalendarDays,
  FileText,
} from "lucide-react";

import {
  FaInstagram,
  FaYoutube,
  FaFacebook,
  FaTwitter,
  FaWhatsapp,
  FaEnvelope,
  FaLinkedin,
  FaPinterestP,
  FaSnapchatGhost,
  FaTelegramPlane,
  FaTwitch,
  FaDiscord,
  FaSpotify,
  FaGithub,
  FaBehance,
  FaDribbble,
} from "react-icons/fa";
export const CATEGORIES = [
  // Business / Industry
  {
    id: "fashion",
    label: "Fashion & apparel",
    icon: Shirt,
  },

  {
    id: "food",
    label: "Food & beverage",
    icon: Utensils,
  },

  {
    id: "beauty",
    label: "Beauty & wellness",
    icon: Sparkles,
  },

  {
    id: "fitness",
    label: "Fitness & sport",
    icon: Dumbbell,
  },

  {
    id: "art",
    label: "Art & design",
    icon: Palette,
  },

  {
    id: "tech",
    label: "Technology",
    icon: Cpu,
  },

  {
    id: "education",
    label: "Education",
    icon: GraduationCap,
  },

  {
    id: "retail",
    label: "Retail & goods",
    icon: ShoppingBag,
  },

  {
    id: "consulting",
    label: "Consulting",
    icon: Briefcase,
  },


  // Creator / Personal
  {
    id: "streamer",
    label: "Streamer",
    icon: Radio,
  },

  {
    id: "lifestyle",
    label: "Lifestyle builder",
    icon: Heart,
  },

  {
    id: "blogger",
    label: "Blogger",
    icon: PenLine,
  },


  // Other
  {
    id: "other",
    label: "Something else",
    icon: MoreHorizontal,
  },
];

export const THEMES = [
  {
    id: "meadow",
    label: "Meadow",
    hex: "#059669",
    swatches: {
      primary: {
        color: "emerald-600",
        bg: "bg-emerald-600",
        text: "text-emerald-600",
        border: "border-emerald-600",
        hover: {
          bg: "hover:bg-emerald-700",
          text: "hover:text-emerald-700",
          border: "hover:border-emerald-700",
        },
      },
      secondary: {
        color: "teal-400",
        bg: "bg-teal-400",
        text: "text-teal-400",
        border: "border-teal-400",
        hover: {
          bg: "hover:bg-teal-500",
          text: "hover:text-teal-500",
          border: "hover:border-teal-500",
        },
      },
      light: {
        color: "emerald-50",
        bg: "bg-emerald-50",
        text: "text-emerald-50",
        border: "border-emerald-50",
        hover: {
          bg: "hover:bg-emerald-100",
          text: "hover:text-emerald-100",
          border: "hover:border-emerald-100",
        },
      },
    },
  },

  {
    id: "midnight",
    label: "Midnight",
    hex: "#0f172a",
    swatches: {
      primary: {
        color: "slate-900",
        bg: "bg-slate-900",
        text: "text-slate-900",
        border: "border-slate-900",
        hover: {
          bg: "hover:bg-slate-800",
          text: "hover:text-slate-800",
          border: "hover:border-slate-800",
        },
      },
      secondary: {
        color: "violet-500",
        bg: "bg-violet-500",
        text: "text-violet-500",
        border: "border-violet-500",
        hover: {
          bg: "hover:bg-violet-600",
          text: "hover:text-violet-600",
          border: "hover:border-violet-600",
        },
      },
      light: {
        color: "slate-50",
        bg: "bg-slate-50",
        text: "text-slate-50",
        border: "border-slate-50",
        hover: {
          bg: "hover:bg-slate-100",
          text: "hover:text-slate-100",
          border: "hover:border-slate-100",
        },
      },
    },
  },

  {
    id: "sandstone",
    label: "Sandstone",
    hex: "#b45309",
    swatches: {
      primary: {
        color: "amber-700",
        bg: "bg-amber-700",
        text: "text-amber-700",
        border: "border-amber-700",
        hover: {
          bg: "hover:bg-amber-800",
          text: "hover:text-amber-800",
          border: "hover:border-amber-800",
        },
      },
      secondary: {
        color: "orange-400",
        bg: "bg-orange-400",
        text: "text-orange-400",
        border: "border-orange-400",
        hover: {
          bg: "hover:bg-orange-500",
          text: "hover:text-orange-500",
          border: "hover:border-orange-500",
        },
      },
      light: {
        color: "amber-50",
        bg: "bg-amber-50",
        text: "text-amber-50",
        border: "border-amber-50",
        hover: {
          bg: "hover:bg-amber-100",
          text: "hover:text-amber-100",
          border: "hover:border-amber-100",
        },
      },
    },
  },

  {
    id: "blossom",
    label: "Blossom",
    hex: "#f43f5e",
    swatches: {
      primary: {
        color: "rose-500",
        bg: "bg-rose-500",
        text: "text-rose-500",
        border: "border-rose-500",
        hover: {
          bg: "hover:bg-rose-600",
          text: "hover:text-rose-600",
          border: "hover:border-rose-600",
        },
      },
      secondary: {
        color: "pink-300",
        bg: "bg-pink-300",
        text: "text-pink-300",
        border: "border-pink-300",
        hover: {
          bg: "hover:bg-pink-400",
          text: "hover:text-pink-400",
          border: "hover:border-pink-400",
        },
      },
      light: {
        color: "rose-50",
        bg: "bg-rose-50",
        text: "text-rose-50",
        border: "border-rose-50",
        hover: {
          bg: "hover:bg-rose-100",
          text: "hover:text-rose-100",
          border: "hover:border-rose-100",
        },
      },
    },
  },

  {
    id: "citrus",
    label: "Citrus",
    hex: "#f97316",
    swatches: {
      primary: {
        color: "orange-500",
        bg: "bg-orange-500",
        text: "text-orange-500",
        border: "border-orange-500",
        hover: {
          bg: "hover:bg-orange-600",
          text: "hover:text-orange-600",
          border: "hover:border-orange-600",
        },
      },
      secondary: {
        color: "yellow-400",
        bg: "bg-yellow-400",
        text: "text-yellow-400",
        border: "border-yellow-400",
        hover: {
          bg: "hover:bg-yellow-500",
          text: "hover:text-yellow-500",
          border: "hover:border-yellow-500",
        },
      },
      light: {
        color: "orange-50",
        bg: "bg-orange-50",
        text: "text-orange-50",
        border: "border-orange-50",
        hover: {
          bg: "hover:bg-orange-100",
          text: "hover:text-orange-100",
          border: "hover:border-orange-100",
        },
      },
    },
  },

  {
    id: "ocean",
    label: "Ocean",
    hex: "#2563eb",
    swatches: {
      primary: {
        color: "blue-600",
        bg: "bg-blue-600",
        text: "text-blue-600",
        border: "border-blue-600",
        hover: {
          bg: "hover:bg-blue-700",
          text: "hover:text-blue-700",
          border: "hover:border-blue-700",
        },
      },
      secondary: {
        color: "cyan-400",
        bg: "bg-cyan-400",
        text: "text-cyan-400",
        border: "border-cyan-400",
        hover: {
          bg: "hover:bg-cyan-500",
          text: "hover:text-cyan-500",
          border: "hover:border-cyan-500",
        },
      },
      light: {
        color: "blue-50",
        bg: "bg-blue-50",
        text: "text-blue-50",
        border: "border-blue-50",
        hover: {
          bg: "hover:bg-blue-100",
          text: "hover:text-blue-100",
          border: "hover:border-blue-100",
        },
      },
    },
  },

  {
    id: "lavender",
    label: "Lavender",
    hex: "#7c3aed",
    swatches: {
      primary: {
        color: "violet-600",
        bg: "bg-violet-600",
        text: "text-violet-600",
        border: "border-violet-600",
        hover: {
          bg: "hover:bg-violet-700",
          text: "hover:text-violet-700",
          border: "hover:border-violet-700",
        },
      },
      secondary: {
        color: "fuchsia-400",
        bg: "bg-fuchsia-400",
        text: "text-fuchsia-400",
        border: "border-fuchsia-400",
        hover: {
          bg: "hover:bg-fuchsia-500",
          text: "hover:text-fuchsia-500",
          border: "hover:border-fuchsia-500",
        },
      },
      light: {
        color: "violet-50",
        bg: "bg-violet-50",
        text: "text-violet-50",
        border: "border-violet-50",
        hover: {
          bg: "hover:bg-violet-100",
          text: "hover:text-violet-100",
          border: "hover:border-violet-100",
        },
      },
    },
  },

  {
    id: "sky",
    label: "Sky",
    hex: "#0284c7",
    swatches: {
      primary: {
        color: "sky-600",
        bg: "bg-sky-600",
        text: "text-sky-600",
        border: "border-sky-600",
        hover: {
          bg: "hover:bg-sky-700",
          text: "hover:text-sky-700",
          border: "hover:border-sky-700",
        },
      },
      secondary: {
        color: "cyan-300",
        bg: "bg-cyan-300",
        text: "text-cyan-300",
        border: "border-cyan-300",
        hover: {
          bg: "hover:bg-cyan-400",
          text: "hover:text-cyan-400",
          border: "hover:border-cyan-400",
        },
      },
      light: {
        color: "sky-50",
        bg: "bg-sky-50",
        text: "text-sky-50",
        border: "border-sky-50",
        hover: {
          bg: "hover:bg-sky-100",
          text: "hover:text-sky-100",
          border: "hover:border-sky-100",
        },
      },
    },
  },

  {
    id: "berry",
    label: "Berry",
    hex: "#c026d3",
    swatches: {
      primary: {
        color: "fuchsia-600",
        bg: "bg-fuchsia-600",
        text: "text-fuchsia-600",
        border: "border-fuchsia-600",
        hover: {
          bg: "hover:bg-fuchsia-700",
          text: "hover:text-fuchsia-700",
          border: "hover:border-fuchsia-700",
        },
      },
      secondary: {
        color: "pink-400",
        bg: "bg-pink-400",
        text: "text-pink-400",
        border: "border-pink-400",
        hover: {
          bg: "hover:bg-pink-500",
          text: "hover:text-pink-500",
          border: "hover:border-pink-500",
        },
      },
      light: {
        color: "fuchsia-50",
        bg: "bg-fuchsia-50",
        text: "text-fuchsia-50",
        border: "border-fuchsia-50",
        hover: {
          bg: "hover:bg-fuchsia-100",
          text: "hover:text-fuchsia-100",
          border: "hover:border-fuchsia-100",
        },
      },
    },
  },

  {
    id: "ink",
    label: "Ink",
    hex: "#171717",
    swatches: {
      primary: {
        color: "neutral-900",
        bg: "bg-neutral-900",
        text: "text-neutral-900",
        border: "border-neutral-900",
        hover: {
          bg: "hover:bg-neutral-800",
          text: "hover:text-neutral-800",
          border: "hover:border-neutral-800",
        },
      },
      secondary: {
        color: "neutral-500",
        bg: "bg-neutral-500",
        text: "text-neutral-500",
        border: "border-neutral-500",
        hover: {
          bg: "hover:bg-neutral-600",
          text: "hover:text-neutral-600",
          border: "hover:border-neutral-600",
        },
      },
      light: {
        color: "neutral-50",
        bg: "bg-neutral-50",
        text: "text-neutral-50",
        border: "border-neutral-50",
        hover: {
          bg: "hover:bg-neutral-100",
          text: "hover:text-neutral-100",
          border: "hover:border-neutral-100",
        },
      },
    },
  },
];
export const PLATFORMS = [
  // ================= SOCIAL =================
  {
    id: "instagram",
    type: "social",
    label: "Instagram",
    title: "INSTAGRAM",
    subtitle: "Follow us on Instagram",
    icon: FaInstagram,
    placeholder: "https://instagram.com/yourname",
    style: {
      bg: "bg-gradient-to-br from-[#833AB4] via-[#E1306C] to-[#FCAF45]",
      text: "text-white",
      border: "border-[#E1306C]",
      hover: "hover:opacity-90",
    },
  },

  {
    id: "tiktok",
    type: "social",
    label: "TikTok",
    title: "TIKTOK",
    subtitle: "Watch our latest videos",
    icon: Music2,
    placeholder: "https://tiktok.com/@yourname",
    style: {
      bg: "bg-black",
      text: "text-white",
      border: "border-black",
      hover: "hover:bg-gray-900",
    },
  },

  {
    id: "youtube",
    type: "social",
    label: "YouTube",
    title: "YOUTUBE",
    subtitle: "Watch our videos",
    icon: FaYoutube,
    placeholder: "https://youtube.com/@yourname",
    style: {
      bg: "bg-[#FF0000]",
      text: "text-white",
      border: "border-[#FF0000]",
      hover: "hover:bg-[#CC0000]",
    },
  },

  {
    id: "facebook",
    type: "social",
    label: "Facebook",
    title: "FACEBOOK",
    subtitle: "Follow us on Facebook",
    icon: FaFacebook,
    placeholder: "https://facebook.com/yourname",
    style: {
      bg: "bg-[#1877F2]",
      text: "text-white",
      border: "border-[#1877F2]",
      hover: "hover:bg-[#166FE5]",
    },
  },

  {
    id: "twitter",
    type: "social",
    label: "X / Twitter",
    title: "X / TWITTER",
    subtitle: "Follow us for updates",
    icon: FaTwitter,
    placeholder: "https://x.com/yourname",
    style: {
      bg: "bg-black",
      text: "text-white",
      border: "border-black",
      hover: "hover:bg-gray-900",
    },
  },

  {
    id: "linkedin",
    type: "social",
    label: "LinkedIn",
    title: "LINKEDIN",
    subtitle: "Connect with us",
    icon: FaLinkedin,
    placeholder: "https://linkedin.com/in/yourname",
    style: {
      bg: "bg-[#0A66C2]",
      text: "text-white",
      border: "border-[#0A66C2]",
      hover: "hover:bg-[#0959A8]",
    },
  },

  {
    id: "pinterest",
    type: "social",
    label: "Pinterest",
    title: "PINTEREST",
    subtitle: "Explore our inspiration",
    icon: FaPinterestP,
    placeholder: "https://pinterest.com/yourname",
    style: {
      bg: "bg-[#E60023]",
      text: "text-white",
      border: "border-[#E60023]",
      hover: "hover:bg-[#CC001F]",
    },
  },

  {
    id: "snapchat",
    type: "social",
    label: "Snapchat",
    title: "SNAPCHAT",
    subtitle: "Add us on Snapchat",
    icon: FaSnapchatGhost,
    placeholder: "https://snapchat.com/add/yourname",
    style: {
      bg: "bg-[#FFFC00]",
      text: "text-black",
      border: "border-[#FFFC00]",
      hover: "hover:bg-[#E6E300]",
    },
  },

  {
    id: "telegram",
    type: "social",
    label: "Telegram",
    title: "TELEGRAM",
    subtitle: "Join our Telegram",
    icon: FaTelegramPlane,
    placeholder: "https://t.me/yourname",
    style: {
      bg: "bg-[#229ED9]",
      text: "text-white",
      border: "border-[#229ED9]",
      hover: "hover:bg-[#1D8BC2]",
    },
  },

  // ================= STREAMING =================
  {
    id: "twitch",
    type: "streaming",
    label: "Twitch",
    title: "TWITCH",
    subtitle: "Watch us live",
    icon: FaTwitch,
    placeholder: "https://twitch.tv/yourname",
    style: {
      bg: "bg-[#9146FF]",
      text: "text-white",
      border: "border-[#9146FF]",
      hover: "hover:bg-[#772CE8]",
    },
  },

  {
    id: "discord",
    type: "streaming",
    label: "Discord",
    title: "DISCORD",
    subtitle: "Join our community",
    icon: FaDiscord,
    placeholder: "https://discord.gg/yourinvite",
    style: {
      bg: "bg-[#5865F2]",
      text: "text-white",
      border: "border-[#5865F2]",
      hover: "hover:bg-[#4752C4]",
    },
  },

  {
    id: "spotify",
    type: "streaming",
    label: "Spotify",
    title: "SPOTIFY",
    subtitle: "Listen on Spotify",
    icon: FaSpotify,
    placeholder: "https://open.spotify.com/",
    style: {
      bg: "bg-[#1DB954]",
      text: "text-white",
      border: "border-[#1DB954]",
      hover: "hover:bg-[#18A348]",
    },
  },

  // ================= CONTACT =================
  {
    id: "whatsapp",
    type: "contact",
    label: "WhatsApp",
    title: "WHATSAPP",
    subtitle: "Chat with us",
    icon: FaWhatsapp,
    placeholder: "https://wa.me/213XXXXXXXXX",
    style: {
      bg: "bg-[#25D366]",
      text: "text-white",
      border: "border-[#25D366]",
      hover: "hover:bg-[#20BD5A]",
    },
  },

  {
    id: "email",
    type: "contact",
    label: "Email",
    title: "EMAIL",
    subtitle: "Send us an email",
    icon: FaEnvelope,
    placeholder: "your@email.com",
    style: {
      bg: "bg-gray-600",
      text: "text-white",
      border: "border-gray-600",
      hover: "hover:bg-gray-700",
    },
  },

  {
    id: "phone",
    type: "contact",
    label: "Phone",
    title: "CALL US",
    subtitle: "Click to call",
    icon: Phone,
    placeholder: "+213XXXXXXXXX",
    style: {
      bg: "bg-emerald-600",
      text: "text-white",
      border: "border-emerald-600",
      hover: "hover:bg-emerald-700",
    },
  },

  {
    id: "location",
    type: "contact",
    label: "Location",
    title: "OUR LOCATION",
    subtitle: "Find us on the map",
    icon: MapPin,
    placeholder: "https://maps.google.com/?q=your+location",
    style: {
      bg: "bg-red-600",
      text: "text-white",
      border: "border-red-600",
      hover: "hover:bg-red-700",
    },
  },

  // ================= BUSINESS =================
  {
    id: "shop",
    type: "business",
    label: "Online Shop",
    title: "ONLINE STORE",
    subtitle: "Shop our collection",
    icon: Store,
    placeholder: "https://yourshop.com",
    style: {
      bg: "bg-orange-500",
      text: "text-white",
      border: "border-orange-500",
      hover: "hover:bg-orange-600",
    },
  },

  {
    id: "website",
    type: "business",
    label: "Website",
    title: "WEBSITE",
    subtitle: "Visit our website",
    icon: Globe,
    placeholder: "https://yourwebsite.com",
    style: {
      bg: "bg-indigo-600",
      text: "text-white",
      border: "border-indigo-600",
      hover: "hover:bg-indigo-700",
    },
  },

  {
    id: "booking",
    type: "business",
    label: "Booking",
    title: "BOOK NOW",
    subtitle: "Schedule an appointment",
    icon: CalendarDays,
    placeholder: "https://yourwebsite.com/book",
    style: {
      bg: "bg-purple-600",
      text: "text-white",
      border: "border-purple-600",
      hover: "hover:bg-purple-700",
    },
  },

  // ================= CREATOR =================
  {
    id: "github",
    type: "creator",
    label: "GitHub",
    title: "GITHUB",
    subtitle: "View my projects",
    icon: FaGithub,
    placeholder: "https://github.com/yourname",
    style: {
      bg: "bg-[#181717]",
      text: "text-white",
      border: "border-[#181717]",
      hover: "hover:bg-black",
    },
  },

  {
    id: "behance",
    type: "creator",
    label: "Behance",
    title: "BEHANCE",
    subtitle: "View my creative work",
    icon: FaBehance,
    placeholder: "https://behance.net/yourname",
    style: {
      bg: "bg-[#1769FF]",
      text: "text-white",
      border: "border-[#1769FF]",
      hover: "hover:bg-[#0057E7]",
    },
  },

  {
    id: "dribbble",
    type: "creator",
    label: "Dribbble",
    title: "DRIBBBLE",
    subtitle: "View my designs",
    icon: FaDribbble,
    placeholder: "https://dribbble.com/yourname",
    style: {
      bg: "bg-[#EA4C89]",
      text: "text-white",
      border: "border-[#EA4C89]",
      hover: "hover:bg-[#D43B76]",
    },
  },

  {
    id: "portfolio",
    type: "creator",
    label: "Portfolio",
    title: "MY PORTFOLIO",
    subtitle: "Explore my work",
    icon: FileText,
    placeholder: "https://yourportfolio.com",
    style: {
      bg: "bg-slate-700",
      text: "text-white",
      border: "border-slate-700",
      hover: "hover:bg-slate-800",
    },
  },

  // ================= CUSTOM =================
  {
    id: "custom",
    type: "custom",
    label: "Custom Link",
    title: "CUSTOM LINK",
    subtitle: "Visit this link",
    icon: Link2,
    placeholder: "https://yourlink.com",
    style: {
      bg: "bg-gray-800",
      text: "text-white",
      border: "border-gray-800",
      hover: "hover:bg-gray-900",
    },
  },
];
export const TEMPLATES = [{
                id: "card1",
                active:true,
                component:"card1",
                img: "/cards/card1.jpg",
                name:"Modern"
      },

      {
                      id: "card2",
                      active:true,
                      component:"card2",
                      img: "/cards/card2.jpg",
                      name:"OLD SCHOOL"
      },
      {
                      id: "card3",
                      active:true,
                      component:"card3",
                      img: "/cards/card3.jpg",
                      name:"VINTAGE"
      },
      {
                      id: "card4",
                      active:true,
                      component:"card4",
                      img: "/cards/card4.jpg",
                      name:"NEW"
      },
      {
                      id: "card5",
                      active:true,
                      component:"card5",
                      img: "/cards/card5.jpg",
                      name:"Profile"
      }

]
export const QR_TEMPLATES = [
  {
    id: "Minimal",
    component:"qr1",
    name: "Minimal",
    dotsType: "square",
    cornersSquareType: "square",
  },
  {
    id: "Modern",
    component:"qr2",
    name: "Modern",
    dotsType: "rounded",
    cornersSquareType: "extra-rounded",
  },
    {
    id: "Modern",
    component:"qr3",
    name: "Modern",
    dotsType: "rounded",
    cornersSquareType: "extra-rounded",
  },
    {
    id: "Modern",
    component:"qr4",
    name: "Modern",
    dotsType: "rounded",
    cornersSquareType: "extra-rounded",
  },
    {
    id: "Modern",
    component:"qr5",
    name: "Modern",
    dotsType: "rounded",
    cornersSquareType: "extra-rounded",
  },
 
];

export const HELP = {
  displayName:["/images/help/displayName.png"],
}